import { H4, P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const TableBody = styled.tbody`
  display: grid;
  grid-row-gap: 8px;
  padding: 24px;
  border-radius: ${themeStyle.radiusLarge};
  background: ${themeStyle.varBackgroundAlt};
  border: 1px solid ${themeStyle.varInkLight};
  box-shadow: ${themeStyle.varShadowSoft};
`;

export const Row = styled.tr<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-column-gap: 12px;
`;

export const SectionTitle = styled(H4).attrs(() => ({ as: 'td' }))`
  padding-top: 8px;
  padding-bottom: 25px;
  height: 28px;
  border-bottom: 1px solid ${themeStyle.varInkSuperLight};
  margin-bottom: 8px;
`;

export const ComparisonItem = styled(P2).attrs(() => ({ as: 'td' }))<{
  isKey?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ isKey }) => (isKey ? 'start' : 'center')};
  width: 100%;
  padding: 0;
  margin: 0;
  gap: ${({ isKey }) => (isKey ? '8px' : '4px')};
  line-height: 20px;
  margin-bottom: 8px;

  span,
  a {
    text-align: ${({ isKey }) => (isKey ? 'left' : 'center')};
    margin-left: ${({ isKey }) => (isKey ? '-4px' : '0px')};
    white-space: pre-wrap;
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    cursor: ${({ isKey }) => (isKey ? 'pointer' : 'default')};
    transform: rotate(${({ isKey }) => (isKey ? '180deg' : '0deg')});
  }
`;
